import React, { Component } from "react";
//import {observer} from 'mobx-react';
import {Container, Button, FormGroup, FormControl, Form, FormLabel, Image} from "react-bootstrap";
import {withRouter} from 'react-router-dom';
import Cookies from 'universal-cookie';

import appLogo from '../images/ARIVA_WHITE.png';
//import { getUserStore } from '../../stores/Stores';
//import { Loading } from './Loading/Loading';
import t from '../utils/localization';
 
 class Login extends Component {
    state = {
    email: '',
    password: '',
    errorMessage: '',
  };

  // The idea of removing cookies is a good one.
  // Issues is that it removes too many. Need to get cookie prefix for this
  // instance and remove all cookies that begin with said prefix.
  componentDidMount(){
/*
    //delete old cookies on login page reload
    let cookie = new Cookies();
    let cookiesdata = (cookie.getAll());
    
    Object.keys(cookiesdata).forEach(function(key) {
      cookie = new Cookies();
      var value = key;
       cookie.remove(value, {path : '/', domain: '.passur.com'});
    });
 */
  }

  handleInputChange = (event) => {
    this.setState({
      errorMessage: '',
    });
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  setCookie(responseData) {
    const cookies = new Cookies();

    cookies.set(responseData.cookies[0].name, responseData.cookies[0].value, {path:"/", sameSite:"strict", secure:true, domain : responseData.cookies[0].domain});
    cookies.set(responseData.cookies[1].name, responseData.cookies[1].value, {path:"/", sameSite:"strict", secure:true, domain : responseData.cookies[1].domain});
 
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { email, password } = this.state;

    //Authenticate email and password
    try {
        if(email !== '' && password !== '')
        {
          const userinfostr="?username="+email+ "&password=" + password;

          //Verify login and fetch cookies
          const url = "/verify" + userinfostr; 

          fetch(url,
            { method: "GET",
              credentials: "include",
            }).then(response => {
                if (!response.ok){
                    if(response.status ===  401){
                        this.setState({ errorMessage : t('login.errorMsgAuth')});
                        return;
                    }
                    else{
                        this.setState({ errorMessage : t('login.errorMsgNetw')});
                        throw Error(response.statusText);
                    }
                }
                else
                {
                  return response.json();
                }
              }).then(responseJSON=>{
                if (responseJSON && responseJSON.status)
                  { 
                    try{
                        this.setCookie(responseJSON);
                        window.location.replace(responseJSON.application);
                    }
                    catch(error){
                       console.log(error.message);
                       return;
                    }
                  }
              }).catch(error=>{
		            console.log(error);
	            	return;
 	      });
	}
         else
         {
           return;
         }
     }
    catch (error) {
      console.log(error.stack);
      this.setState({ errorMessage: error.message })
      return;
    }
  };



    render() {
  /*   if(this.state.loading){
        return ( 
          <div id="login">
            <Loading/>
          </div>);
         
      }
     else
    */
       return (
          <div id="login">
            <Container className="loginBox" >
             <Container className="loginBoxHeader" >
               <Image  src={appLogo} alt="PASSUR Ariva" />
              </Container>
              <Container className="loginBoxBody">
               <Form onSubmit={this.handleSubmit}>
                <FormGroup controlId="email">
                    <FormLabel>{t('login.inputUserName')}</FormLabel>
                    <FormControl
                       className="inputText" 
                       placeholder={t('login.inputUserName')}
                       required
                       value={this.state.email}
                       onChange={this.handleInputChange}
                        />
                    </FormGroup>

                <FormGroup controlId="password">
                    <FormLabel>{t('login.inputPassword')}</FormLabel>
                    <FormControl 
                      type="password" 
                      className="inputText" 
                      placeholder={t('login.inputPassword')}
                      required
                      value={this.state.password}
                      onChange={this.handleInputChange} 
                      />
                </FormGroup>


                <Button type="submit" className="btn btn-primary btn-block">{t('login.buttonLogin')}</Button>
            </Form>
          </Container>
        <Container className="errorBox">{this.state.errorMessage}</Container>
          </Container>
          </div>
        );
    }
}

export default withRouter(Login);
